// Matches Visma Connect name validation.
// Should contain only letters, numbers, spaces, and the following special characters: '-:~!@#$^&*()_+ but must not start with a space.
// Unicode property escapes (\p{L}) is still not supported by firefox and others in 2020-03-23, so we use \u00C0-\u00FF instead.
// Besides the regular expression name validation another rule is enforced: Dot '.' is allowed if it's not followed by two letters.
export default function isValidName(name: string) {
    return (
        /^[a-zA-Z\u00C0-\u00FF0-9.'\-:~!@#$^&*()_+][a-zA-Z\u00C0-\u00FF0-9\s.'\-:~!@#$^&*()_+]*$/.test(name) &&
        stringContainsTLD(name)
    );
}

function stringContainsTLD(name: string) {
    return /.[a-zA-Z]{2,}/.test(name);
}
